/* import __COLOCATED_TEMPLATE__ from './edit-company-team-modal.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';
import { closeModal } from 'sh-www/utils/modal-controls';

const CLASS_NAME = 'SH-c-edit-company-team-modal';

class EditCompanyTeamModal extends Component {
  @service('state-managers/application') applicationStateManager;
  @service('commands/assignment-commands') assignmentCommandService;
  @service session;

  @tracked companyTeamId = this.args.model.assignment.companyTeam?.id ?? null;

  get className() {
    return CLASS_NAME;
  }

  get userIdToCompanyMembershipMap() {
    const { companyMemberships } = this.args.model.company;
    return companyMemberships.reduce((accum, companyMembership) => {
      accum[companyMembership.user.id] = companyMembership;
      return accum;
    }, {});
  }

  get userIdToCompanyTeamsMap() {
    const { companyMemberships } = this.args.model.company;
    return companyMemberships.reduce((accum, member) => {
      accum[member.user.id] = member.companyTeamMemberships.map(({ companyTeam }) => companyTeam);
      return accum;
    }, {});
  }

  get currentUserIsCompanyAdminOrAdmin() {
    const { currentUser } = this.session;
    return currentUser.isCompanyAdmin || currentUser.isAdmin;
  }

  get companyTeamOptions() {
    const teamOptions = [];
    const currentTeam = this.args.model.assignment.companyTeam;
    const { companyTeams } = this.args.model.company;

    if (this.currentUserIsCompanyAdminOrAdmin) {
      teamOptions.push({
        title: 'None',
        value: null,
        selected: currentTeam?.id === null,
      });

      companyTeams.forEach((team) => {
        teamOptions.push({
          title: team.name,
          value: team.id,
          selected: currentTeam?.id === team.id,
        });
      });
    } else {
      const currentUserTeams = this.userIdToCompanyTeamsMap[this.session.currentUser.id] ?? [];
      currentUserTeams.forEach((team) => {
        teamOptions.push({
          title: team.name,
          value: team.id,
          selected: currentTeam?.id === team.id,
        });
      });

      // followers outside this posting's team need dropdown option
      const existingTeamIds = teamOptions.map(({ value }) => value);
      if (currentTeam && !existingTeamIds.includes(currentTeam.id)) {
        teamOptions.push({
          title: currentTeam.name,
          value: currentTeam.id,
          selected: true,
        });
      }
    }

    return teamOptions;
  }

  @task
  *onUpdateCompanyTeam(assignment, updatedCompanyTeamId) {
    try {
      yield this.assignmentCommandService.setCompanyTeam(assignment.id, updatedCompanyTeamId);
      yield this.assignmentCommandService.loadAssignment(assignment.id, ['company-team']);

      closeModal(this);
      this.applicationStateManager.addToast('Project\'s team updated');
    } catch(e) {
      this.applicationStateManager.addToast('Cannot update this posting\'s team');
    }
  }

  @action
  handleTeamSelected(companyTeamId) {
    this.companyTeamId = companyTeamId;
  }

  @action
  handleDismiss() {
    closeModal(this);
  }

  @action
  initializeData() {
    const {
      companyTeamId,
      companyTeamOptions,
    } = this;

    // ensure default selection is sent to server when unchanged
    if (!companyTeamId && companyTeamOptions.length > 0) {
      this.companyTeamId = companyTeamOptions[0].value;
    }
  }
}

export default EditCompanyTeamModal;
